// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.kanban-title[data-v-2d2beef1] {\n  padding: 15px 0;\n  border-bottom: 1px solid #ccc;\n  text-align: center;\n  font-size: 26px;\n  font-weight: bold;\n}\n.search-kan .el-form-item--small.el-form-item[data-v-2d2beef1] {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
